import AutoTestActivation from 'storefront-analytics/dist/auto-test-activation';
import AutoProductAnalytics from 'storefront-analytics/dist/auto-product';
import AutoPromoAnalytics from 'storefront-analytics/dist/auto-promo';
import AutoFooterAnalytics from 'storefront-analytics/dist/auto-footer';
import * as spaAnalytics from 'storefront-analytics/dist/spa-analytics';
import log from '../shared/util/log';
import getDatadogRum from './getDatadogRum';

let executed = false;

export default function init() {
  if (!executed) {
    if (typeof window === 'undefined') {
      log.error('Failed to init analytics due to missing window');
      return;
    }
    const {
      userContextData,
      experimentOverrides,
      analyticsToggles,
      pageContextData,
      optimizelyInitData,
    } = window;
    const [sdkKey, sessionAttributes, activationAttributes, dataFile] = optimizelyInitData;
    log.debug('Init analytics');
    spaAnalytics.init({
      pageData: pageContextData,
      userData: userContextData,
      experimentOverrides,
      analyticsFeatureToggles: analyticsToggles,
      sessionAttributes,
      activationAttributes,
      dataFile,
      sdkKey,
    });
    getDatadogRum();
    AutoTestActivation();
    AutoProductAnalytics();
    AutoPromoAnalytics();
    AutoFooterAnalytics();
    executed = true;
  }
}
